import Connections from './ConnectionsImage'
import ProtocolsImage from './ProtocolsImage'
import UnifyImage from './UnifyImage'
import TwilioEngageImage from './TwilioEngageImage'

const data = [
  {
    key: `connections`,
    title: `Connections`,
    heading: `Connect all of your customer data with a single API`,
    image: <Connections />,
    list: [
      `${process.env.INTEGRATION_COUNT}+ integrations help you collect and activate data across your tech stack`,
      `Seamlessly sync historic archived data into new tools with replay`,
      `Integrate custom sources and destinations with a simple webhook`,
    ],
  },
  {
    key: `protocols`,
    title: `Protocols`,
    heading: `Clean, reliable data to power your business`,
    image: <ProtocolsImage />,
    list: [
      `Align all the teams in your company around a single data dictionary`,
      `Diagnose data quality issues with automatic data validation`,
      `Have confidence in your data with actionable error reporting and daily email digests`,
    ],
  },
  {
    key: `unify`,
    title: `Unify`,
    heading: `Get a complete view of your customer`,
    image: <UnifyImage />,
    list: [
      `Track every interaction to gain a better understanding of customer behavior`,
      `Stitch together each customer’s journey between touchpoints`,
      `Deliver personalized, omnichannel campaigns to real-time targeted audiences`,
    ],
  },
  {
    key: `twilio-engage`,
    title: `Twilio Engage`,
    heading: `Build data-driven, personalized customer experiences at scale`,
    image: <TwilioEngageImage />,
    list: [
      `Activate highly personalized experiences with real-time customer data`,
      `Reach customers where, when, and how they customers want with native email and SMS channels, custom channels, and ${process.env.INTEGRATION_COUNT}+ out-of-the-box integrations`,
      `Build profiles and audiences with real-time customer interactions collected in a privacy-first way`,
    ],
  },
]

export default data
